import React, {useEffect, useState} from 'react';
import ModelViewerTile from "./ModelViewerTile";
import {Button, Layout, Typography, message, Upload, notification} from "antd";
import {getDownloadURL, ref as sRef} from "firebase/storage";
import {default3DAssetsStorage, defaultAssetsStorage, storage} from "../../tools/firebase";
import {track} from "@amplitude/analytics-browser";
import axios from "axios";
import {GLOBAL_CONFIG} from "../../tools/global_config";

const { Title, Text } = Typography;

/* style={{display: "flex", gap: "3em", justifyContent: "center"}} */

const ChooseModel = ({onAssetSelected, assetPath, guid, tkn, onAssetUploaded}) => {
    const [isUploading, setIsUploading] = useState(false);

    const [firstAssetPath, setFirstAssetPath] = useState(null);
    const [secondAssetPath, setSecondAssetPath] = useState(null);
    const [thirdAssetPath, setThirdAssetPath] = useState(null);

    const size = "28rem";

    const uploadProps = {
        name: 'file',
        action: GLOBAL_CONFIG.upload_url,
        headers: {
            authorization: "Bearer " + tkn
        },
        showUploadList: false,
        method: 'POST',
        beforeUpload: (file) => {
            let extension = file.name.split('.').pop();
            const isGLB = extension === "glb" || extension === "gltf";
            //const isGLB = file.type === 'model/gltf+json' || file.type === 'model/gltf-binary';
            if (!isGLB) {
                message.error(`${file.name} is not a GLB file`);
                setIsUploading(false);
            }
            return isGLB || Upload.LIST_IGNORE;
        },
        onChange(info) {
            if (info.file.status !== 'uploading') {
                console.log(info.file, info.fileList);
            }
            if (info.file.status === 'done') {
                startDownloadGeometry(info);
            } else if (info.file.status === 'error') {
                setIsUploading(false);
                message.error(`${info.file.name} file upload failed.`);
            }
        }
    };

    const startDownloadGeometry = async (info) => {
        const assetUrl = await getDownloadURL(sRef(storage, guid + "/" + info.file.name));
        setIsUploading(false);
        onAssetUploaded(assetUrl, [Math.PI, Math.PI / 2, -Math.PI / 2], { position: [-10, 15, 25], fov: 5 });
    }

    const extractDownloadUrls = async () => {
        const answerOne = await getDownloadURL(sRef(default3DAssetsStorage, "axe_test.glb"));
        const answerTwo = await getDownloadURL(sRef(default3DAssetsStorage, "bow_test.glb"));
        const answerThree = await getDownloadURL(sRef(default3DAssetsStorage, "rifle_test.glb"));
        setFirstAssetPath(answerOne);
        setSecondAssetPath(answerTwo);
        setThirdAssetPath(answerThree);
    }

    useEffect(() => {
        extractDownloadUrls();
    }, []);

    return (
        <div style={{backgroundColor: "black", height: "90vh"}}>
            <Layout>
                <Title
                    level={1}
                    style={{color: "white", marginTop: "2em", marginBottom: "2em", fontFamily: "Avenir"}}
                >
                    {isUploading ? "Uploading your asset..." : "Pick an asset to start"}
                </Title>

                {
                    isUploading ? <div/> : <div className="flex flex-wrap gap-12 justify-center" >
                        <ModelViewerTile
                            className="basis-auto"
                            width={size}
                            height={size}
                            showSelectButton={true}
                            onSelectTap={() => onAssetSelected("axe_test.glb", [Math.PI, Math.PI / 2, -Math.PI / 2], { position: [-10, 15, 25], fov: 5 })}
                            hoverShadow={true}
                            glbPath={firstAssetPath}
                            rotation={[Math.PI, Math.PI / 2, -Math.PI / 2]}
                            camera={{ position: [-10, 15, 25], fov: 5 }}
                        />
                        <ModelViewerTile
                            className="basis-auto"
                            width={size}
                            height={size}
                            showSelectButton={true}
                            onSelectTap={() => onAssetSelected("bow_test.glb", [Math.PI, Math.PI / 2, -Math.PI / 2], { position: [-10, 15, 25], fov: 5 })}
                            hoverShadow={true}
                            glbPath={secondAssetPath}
                            rotation={[Math.PI, Math.PI / 2, -Math.PI / 2]}
                            camera={{ position: [-10, 15, 25], fov: 5 }}
                        />
                        <ModelViewerTile
                            className="basis-auto"
                            width={size}
                            height={size}
                            showSelectButton={true}
                            onSelectTap={() => onAssetSelected("rifle_test.glb", [Math.PI / 2, 0 , 2.5], { position: [-5, 15, 25], fov: 5 })}
                            hoverShadow={true}
                            glbPath={thirdAssetPath}
                            rotation={[Math.PI / 2, 0 , 2.5]}
                            camera={{ position: [-5, 15, 25], fov: 5 }}
                        />
                    </div>

                }

                <div style={{display: "flex", marginTop: "6em", justifyContent: "center", flexDirection: "column"}}>
                    <div>
                        <Upload {...uploadProps}>
                            <Button
                                type="primary"
                                shape="round"
                                loading={isUploading}
                                style={{width: 380, height: 64, fontSize: 20, backgroundColor: "#1890FF", fontFamily: "Avenir", marginBottom: "1rem"}}
                                onClick={() => {
                                    setIsUploading(true);
                                }}
                            >
                                Upload my own asset
                            </Button>
                        </Upload>

                    </div>
                    <Text
                        type="warning"
                        style={{fontFamily: "Avenir", marginBottom: "2rem"}}
                    >
                        Currently we support only GLB/GLTF file format.
                    </Text>
                </div>

            </Layout>
        </div>
    );
};

export default ChooseModel;